import React from "react";


export default function About() {
  return (
    <div className="about-page">

      {/* Hero Section */}
      <div
        className="about-hero"
        style={{ backgroundImage: "" }}
      >
        <div className="about-hero-overlay">
          <h1>About Us</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="about-content container">
        <h4 className="text-center">Who We Are</h4>

        <p>
          <strong>Brookshire Royale</strong>, established in 2004, is specialized
          in supplying high quality assured hotel linen. Years of experience and
          understanding of customers enable us to offer superior quality products
          at reasonable prices. We have a strong track record of business
          reliability with customers around the world.
        </p>

        <p>
          Our bed linen products enjoy an excellent reputation and customer
          preference due to their durable quality, soft and comfortable material,
          and eco-friendly properties.
        </p>

        <p>
          We specialize in high quality 100% cotton &amp; CVC bedding, as well as
          bath linen, F&amp;B linen, and everything your hotel and luxury rooms
          require. We also supply related materials such as fabric rolls, poly
          staple fiber, and down feather bales for re-processing in local import
          plants.
        </p>

        <p>
          In addition, we constantly strive for complete customer satisfaction
          in this rapidly changing market, delivering efficiency with
          exceptional dedication.
        </p>
      </div>

    </div>
  );
}
